/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/document/editor"/>
import * as $ from "jquery";
import * as rpc from "Core/Medius.Core.Web/Scripts/Medius/core/communication/json/rpc";
import * as _ from "underscore";
import * as taskHandlingContext from "Core/Medius.Core.Web/Scripts/Medius/apps/task/models/taskHandlingContext";
import * as registrationEvents from "Core/Medius.Core.Web/Scripts/Medius/apps/document/events";
import { get } from "Core/Medius.Core.Web/Scripts/Medius/core/fetch/rest";
import { handleError } from "Core/Medius.Core.Web/Scripts/lib/errorHandling/errorHandler";
import { isRejectionManagementEnabled } from "Core/Medius.Core.Web/Scripts/Medius/core/featureToggle";

import * as documentContext from "Core/Medius.Core.Web/Scripts/Medius/apps/task/models/documentContext";

class Editor {
    public context: any = null;
    public documentViewModel: any = null;
    public targetElement: JQuery;
    public contextResource: any;
    public returnUrl: string | undefined;

    constructor(targetElement: any, contextResource: any) {
        this.targetElement = $(targetElement);
        this.contextResource = contextResource;
    }

    public initWithExistingDocument(documentId: number, type: string, returnUrl?: string) {
        this.returnUrl = returnUrl;

        rpc.request('UiDocumentManager', 'GetReclassificationDraft', {
            documentId: documentId,
            targetTypeName: type,
            manual: true
        }).done((data) => {
            isRejectionManagementEnabled() ? this.bindDocumentModelWithSendEmailFlag(data, documentId) : this.bindDocumentModel(data);
        }).fail((error) => {
            this.onGetDocumentError(error);
        });
    }

    public createNewDocument(documentType: string) {
        if (this.documentViewModel && _.isFunction(this.documentViewModel.dispose)) {
            this.documentViewModel.dispose();
        }

        return rpc.request('UiDocumentManager', 'GetNewDocument', {
            documentType: documentType
        }).done((data) => {
            this.bindDocumentModel(data);
        }).fail((error) => {
            this.onGetDocumentError(error);
        });
    }

    private bindDocumentModel(data: any) {
        const context = this.contextResource.newContext();

        taskHandlingContext.extendViewmodelContextFromCreateDocument(context, data.$type);
        documentContext.extendViewmodelContextFromCreateDocument(context, data.$type);

        const documentViewModel = context.create(data);
        if(!documentViewModel.toDto)
            documentViewModel.toDto = context.toJS.bind(context, documentViewModel);

        this.context = context;
        this.documentViewModel = documentViewModel;

        this.targetElement.trigger(registrationEvents.modelBound, documentViewModel);
    }

    private bindDocumentModelWithSendEmailFlag(data: any, documentId: number) {
        const context = this.contextResource.newContext();
        taskHandlingContext.extendViewmodelContextFromCreateDocument(context, data.$type);
        documentContext.extendViewmodelContextFromCreateDocument(context, data.$type);

        const documentViewModel = context.create(data);
        if (!documentViewModel.toDto) {
            documentViewModel.toDto = context.toJS.bind(context, documentViewModel);
        }

        this.context = context;
        this.documentViewModel = documentViewModel;

        const url = `remedium-api/apa/rejectionManagement/invoices/${documentId}/rejection-reason/send-email-flag`;

        get(url)
            .then((res) => {
                const sendEmailToSupplier = res;
                documentViewModel.sendRejectionEmail = sendEmailToSupplier;
                const originalToDto = documentViewModel.toDto;

                documentViewModel.toDto = () => {
                    const dto = originalToDto();
                    dto.sendRejectionEmail = documentViewModel.sendRejectionEmail;
                    return dto;
                };

                this.targetElement.trigger(registrationEvents.modelBound, documentViewModel);
            })
            .catch((err) => {
               handleError(err);
            });
    }

    public onGetDocumentError(error: any) {
        this.targetElement.trigger(registrationEvents.modelLoadError, error);
    }
}

export function create(targetElement: any, contextResource: any) {
    return new Editor(targetElement, contextResource);
}
